import { gql, useQuery } from '@apollo/client';
import { BoxProps } from '@chakra-ui/react';
import * as React from 'react';

import { Footer, FooterButton, FooterButtonLabel } from '@/components/Footer';
import { ECommunityAccessConfig } from '@/graphql-types/globalTypes';
import {
  BookOpenIcon,
  HeadphonesIcon,
  HomeIcon,
  TagIcon,
} from '@/imports/ui/chakra/feather';

import { VanillaMobileNavigation_Query } from './graphql-types/VanillaMobileNavigation_Query';

const QUERY = gql`
  query VanillaMobileNavigation_Query {
    currentUser {
      _id
      canAccessCommunity
      canAccessCommunityReadOnly
    }
    tenant {
      result {
        _id
        communityAccessConfig
      }
    }
  }
`;

export const VanillaMobileNavigation: React.FC<BoxProps> = (props) => {
  const query = useQuery<VanillaMobileNavigation_Query>(QUERY);

  const currentUser = query.data?.currentUser;
  const tenant = query.data?.tenant.result;
  const canAccessCommunity = currentUser
    ? currentUser.canAccessCommunity
    : tenant?.communityAccessConfig === ECommunityAccessConfig.PUBLIC;
  const canAccessCommunityReadOnly = currentUser?.canAccessCommunityReadOnly;

  return (
    <Footer {...props}>
      {canAccessCommunity && (
        <FooterButton href="/community" isExact>
          <HomeIcon boxSize="5" />
          <FooterButtonLabel>Feed</FooterButtonLabel>
        </FooterButton>
      )}

      {canAccessCommunityReadOnly && (
        <FooterButton href="/my-company/community">
          <HeadphonesIcon boxSize="5" />
          <FooterButtonLabel>Community</FooterButtonLabel>
        </FooterButton>
      )}

      {canAccessCommunity && (
        <FooterButton href="/community/tags">
          <TagIcon boxSize="5" />
          <FooterButtonLabel>Tags</FooterButtonLabel>
        </FooterButton>
      )}

      {canAccessCommunity && (
        <FooterButton href="/community/groups">
          <BookOpenIcon boxSize="5" />
          <FooterButtonLabel>Groups</FooterButtonLabel>
        </FooterButton>
      )}
    </Footer>
  );
};
